















import { Component, Vue } from 'vue-property-decorator';
import Bar2 from '@/components/organizationDashboard/charts/Bar2.vue';
import LineBar4 from '@/components/organizationDashboard/charts/Line4.vue';
import LineBar5 from '@/components/organizationDashboard/charts/Line5.vue';
import CharTitleIcon from '@/components/organizationDashboard/eachProject/CharTitleIcon.vue';

@Component({
  components: {
    Bar2,
    LineBar4,
    LineBar5,
    CharTitleIcon,
  },
})
export default class TicketChartCard extends Vue {
  private isChangedChart: boolean = true;
}
